export { default as MainPage } from "./MainPage";
export { default as DownloadPage } from "./DownloadPage";
export { default as HistoryPage } from "./HistoryPage";
